import nvSharedServicesUtilsModule from './nv.shared.services.utils.module';

angular.module(nvSharedServicesUtilsModule).service('NavService', ['$mdSidenav', '$mdComponentRegistry', NavService]);

// TODO
function NavService($mdSidenav, $mdComponentRegistry) {
  return {
    // Info on why `$mdComponentRegistry` is being used (CM) to avoid 'No instance found for handle left' err:
    // http://luxiyalu.com/angular-material-no-instance-found-for-handle-left/

    openNav(nav) {
      $mdComponentRegistry.when(nav).then(() => {
        $mdSidenav(nav).toggle();
      });
    },

    closeNav(nav) {
      $mdComponentRegistry.when(nav).then(() => {
        $mdSidenav(nav).close();
      });
    },
  };
}
